import React from 'react';

interface ImageHeaderProps {
  imageUrl?: string;
  headerContent: React.ReactNode;
}

export const ImageHeader: React.FC<ImageHeaderProps> = ({
  imageUrl = '',
  headerContent,
}) => {
  return (
    <div>
      <div
        className="image-header"
        style={{
          backgroundImage: `url(${imageUrl})`,
        }}
      >
        <div className="image-header-overlay" />
        <div className="image-header-content">
          {headerContent}
        </div>
      </div>
    </div>
  );
};
